
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useBonusLoginList } from '@/modules/bonus/login/model/list';
import { BonusLoginType } from '@/modules/bonus/login/model/mixins';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_BONUS.LOGIN.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = useBonusLoginList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Option, label: 'Time Unit', key: 'timeUnit', options: timeUnits },
                { type: TableColumnType.Text, label: 'Time Duration', key: 'timeDuration' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: BonusLoginType },
                { type: TableColumnType.Text, label: 'Value', key: 'value' },
                { type: TableColumnType.Text, label: 'Ads Boost', key: 'adsBoost' },
                { type: TableColumnType.Text, label: 'Ads Rescue', key: 'adsRescue' },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-pen-square',
                        theme: 'info',
                        tooltip: 'Edit ads',
                        to: { name: ROUTE_NAME_BONUS.LOGIN.ADS, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_BONUS.LOGIN.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_BONUS };
    }
});
